import { BaseApiClient } from '@/services/baseApiClient';
import type { RequestOptions } from '@/utils/request';
import { getQuery } from '@/components/filter/helpers';
import type {
  CreateTenantArgs,
  DeleteTenantArgs,
  GetTenantsArgs,
  GetOneTenantArgs,
  UpdateTenantArgs,
} from './types/args';
import type {
  DeleteTenantResult,
  GetTenantsResult,
  GetOneTenantResult,
  UpdateTenantResult,
  CreateTenantResult,
  GetTenantStatisticsResult,
} from './types/results';
import type { TenantStatsFilter } from './types/filter';

export class TenantsApiClient extends BaseApiClient {
  constructor() {
    super('api/tenants');
  }

  public create(payload: CreateTenantArgs): Promise<CreateTenantResult> {
    return this.http.post('', payload);
  }

  public delete(id: DeleteTenantArgs): Promise<DeleteTenantResult> {
    return this.http.delete(`${id}`);
  }

  public get(filter: GetTenantsArgs, signal: RequestOptions['signal']): Promise<GetTenantsResult> {
    return this.http.get('', { query: getQuery({ ...filter }), signal });
  }

  public getOne(id: GetOneTenantArgs, signal: RequestOptions['signal']): Promise<GetOneTenantResult> {
    return this.http.get(`${id}`, { signal });
  }

  public update({ id, payload }: UpdateTenantArgs): Promise<UpdateTenantResult> {
    return this.http.patch(`${id}`, payload);
  }

  public getTenantStatistics(
    filter: TenantStatsFilter,
    signal: RequestOptions['signal'],
  ): Promise<GetTenantStatisticsResult> {
    return this.http.get('stats', { query: getQuery({ ...filter }), signal });
  }
}
